<template>
  <div>
  <Dropdown
    v-model="valueModel"
    :options="options"
    :auto-scroll="true"
    prepended-placeholder=" "
    :error="error"
    has-search
    :placeholder="label"
    :hide-placeholder="true"
    @open="handleOpenAndFocus"
    @close="closeAndBlur"
  />
  <div
      v-show="error.length > 0"
      class="mt-1 text-xs error-message"
      v-html="error"
  />
  </div>
</template>

<script>
import { getCountriesList } from '@/services/countries-api.js';
import getContext from '@/utilities/get-context';
import { AUSTRALIA_COUNTRY_CODE } from '@/constants';
import Dropdown from './dropdown';

const USA_COUNTRY_CODE = 'US';

export default {
  components: {
    Dropdown,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: String,
      default: '',
    },
    // by default we'll show USA, but for current user we need to show his country(for example, details page)
    isDefaultCountry: {
      type: Boolean,
      default: true,
    },
    countryName: {
      type: String,
      default: '',
    },
    countryId: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
      default: 'Country',
    },
  },
  data() {
    return {
      countries: [],
    };
  },
  computed: {
    valueModel: {
      get() {
        return this.value.id;
      },
      set(value) {
        this.$emit('input', this.countries.find(item => item.id === value));
      },
    },
    options() {
      return this.countries.map(item => ({
        slug: item.id,
        name: item.name,
        vat_percentage: item.vat_percentage,
      }));
    },
    validate() {
      return this.countries.some(item => item.id === this.value.id);
    },
  },
  mounted() {
    this.getCountries();
  },
  methods: {
    async getCountries() {
      const { data } = await getCountriesList();
      if (data && data.items) {
        const countries = data.items;
        const usaIndex = countries.findIndex(country => country.code === USA_COUNTRY_CODE);
        const usa = countries.find(country => country.code === USA_COUNTRY_CODE);
        const australia = countries.find(country => country.code === AUSTRALIA_COUNTRY_CODE);

        let currentCountry = {};

        if (!this.isDefaultCountry && this.countryName.length > 0) {
          currentCountry = countries.find(country => country.name.includes(this.countryName));
        } else if (!this.isDefaultCountry && this.countryId) {
          // team account details page has only country id
          currentCountry = countries.find(country => country.id === this.countryId);
        } else {
          // Get country code from user IP
          const currentCountryCode = getContext().__MA__.user?.visiting_country;
          currentCountry = countries.find(country => country.code === currentCountryCode);
        }

        this.$store.dispatch('setCountryUsa', usa);
        this.$store.dispatch('setCountryAustralia', australia);

        // Move USA option at the top.
        // .splice() will remove an item from array and returns it.
        this.countries = [
          ...countries.splice(usaIndex, 1),
          ...countries,
        ];

        // Preselect First option (USA) by default or current user country
        this.valueModel = currentCountry?.id;
      }
    },
    handleOpenAndFocus() {
      this.$emit('open');
      this.$emit('onFocus');
    },
    closeAndBlur() {
      this.$emit('close');
      this.$emit('onBlur');
    },
  },
};
</script>
<style scoped>
.error-message {
  color: #ee5951;
}
</style>